<!--  -->
<template>
  <!-- <el-tag v-show="meeting.meeting_status === 0" size="mini">已预约</el-tag>
      <el-tag v-show="meeting.meeting_status === 1" size="mini">进行中</el-tag>
      <el-tag v-show="meeting.meeting_status === 2" size="mini">已结束</el-tag>
      <el-tag v-show="meeting.meeting_status === 3" size="mini">未进行</el-tag>
      <el-tag v-show="meeting.meeting_status === 4" size="mini">已取消</el-tag>
      <el-tag v-show="meeting.meeting_status === 5" size="mini"
        >决议处理中</el-tag
      >
      <el-tag v-show="meeting.meeting_status === 6" size="mini"
        >会议待评分</el-tag
      >
      <el-tag v-show="meeting.meeting_status === 7" size="mini"
        >已完成</el-tag
      > -->
  <span>
    <el-tag
      v-for="(item, index) in meeting.statusList"
      :key="index"
      v-show="meeting_status === item.value"
      size="mini"
      :type="item.type"
      >{{ item.name }}</el-tag
    >
  </span>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  props: ['meeting_status'],
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      meeting: {
        statusList: [
          {
            name: '已预约',
            value: 0,
            type: 'success'
          },
          {
            name: '进行中',
            value: 1,
            type: 'warning'
          },
          {
            name: '已结束',
            value: 2,
            type: 'warning'
          },
          {
            name: '未进行',
            value: 3,
            type: 'warning'
          },
          {
            name: '已取消',
            value: 4,
            type: 'danger'
          },
          {
            name: '决议处理中',
            value: 5,
            type: 'warning'
          },
          {
            name: '会议待评分',
            value: 6,
            type: 'warning'
          },
          {
            name: '已完成',
            value: 7,
            type: 'success'
          }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
</style>
